export default __webpack_public_path__ + "static/media/giftbox.3b52138e.png";